import { cardItems } from '@/mocks/home';

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-4xl font-heading font-black text-foreground-950 mb-3">
              精选推荐
            </h2>
            <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
              深度影评、专题盘点与观影指南
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {cardItems.slice(0, 3).map((card) => (
              <article
                key={card.id}
                className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="relative w-full aspect-[3/2] overflow-hidden">
                  <img
                    src={card.image}
                    alt={`春色影视 - ${card.title}`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <span className="absolute top-3 left-3 px-2.5 py-1 bg-accent-500 text-background-50 text-xs font-bold rounded-md whitespace-nowrap">
                    {card.category}
                  </span>
                </div>
                <div className="p-5">
                  <h3 className="text-base font-heading font-bold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
                    {card.title}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                    {card.excerpt}
                  </p>
                  <span className="text-xs text-foreground-400">{card.date}</span>
                </div>
              </article>
            ))}
          </div>

          <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
            {cardItems.slice(3).map((card) => (
              <article
                key={card.id}
                className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="relative w-full aspect-[3/2] overflow-hidden">
                  <img
                    src={card.image}
                    alt={`春色影视 - ${card.title}`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <span className="absolute top-3 left-3 px-2.5 py-1 bg-accent-500 text-background-50 text-xs font-bold rounded-md whitespace-nowrap">
                    {card.category}
                  </span>
                </div>
                <div className="p-4">
                  <h3 className="text-sm font-heading font-bold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
                    {card.title}
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-2">
                    {card.excerpt}
                  </p>
                  <span className="text-xs text-foreground-400">{card.date}</span>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}